import { Injectable } from '@angular/core';
declare let document: any;

@Injectable({ providedIn: 'root' })

export class RecaptchaLoaderService {

    loadScript(scriptSrc: string) {
        return new Promise((resolve, reject) => {
            let name = 'googleRecaptchaV2api';
            // load script
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = scriptSrc;
            script.defer = true;
            script.async = true;
            if (script.readyState) {  // IE
                script.onreadystatechange = () => {
                    if (script.readyState === 'loaded' || script.readyState === 'complete') {
                        script.onreadystatechange = null;
                        resolve({ script: name, loaded: true, status: 'Loaded' });
                    }
                };
            } else {  // Others
                script.onload = () => {
                    resolve({ script: name, loaded: true, status: 'Loaded' });
                };
            }
            script.onerror = (error: any) => resolve({ script: name, loaded: false, status: 'Loaded' });
            document.getElementsByTagName('head')[0].appendChild(script);
        });
    }
}
